export default __webpack_public_path__ + "static/background1-1020053e98d85a5e8873f9016de5c2e5.jpg";